import React, { useState } from 'react';
import ResponsiveAppBar from '../ResponsiveAppBar/ResponsiveAppBar'
import AppRequestForm from '../AppRequestForm/AppRequestForm'
import Footer from '../Footer/Footer'
import Grid from '@mui/material/Grid';


function App() {

  return (
    <>

      <ResponsiveAppBar></ResponsiveAppBar>

      <Grid
        container
        spacing={0}
        direction='column'
        alignItems='center'
        justifyContent='center'
        sx={{ textAlign: 'center', marginTop: '8px' }}>
        <Grid item xs={12}>
          <AppRequestForm></AppRequestForm>
        </Grid>
      </Grid>

      <br/>

      <Footer/>

    </>
  );
}

export default App;
